const MillisecondsPerDay = 24 * 60 * 60 * 1000;

type AdminDateValue = string | Date;

const toAdminTimestamp = (value: AdminDateValue): number => {
  const timestamp = value instanceof Date ? value.getTime() : Date.parse(value);
  return Number.isFinite(timestamp) ? timestamp : Number.NaN;
};

export const getAdminUtcDaysUntil = (
  value: AdminDateValue,
  now: Date = new Date()
): number => Math.ceil((toAdminTimestamp(value) - now.getTime()) / MillisecondsPerDay);

export const isWithinAdminUtcDays = (
  value: AdminDateValue,
  days: number,
  now: Date = new Date()
): boolean => {
  const difference = toAdminTimestamp(value) - now.getTime();
  return Number.isFinite(difference) && difference > 0 && difference <= days * MillisecondsPerDay;
};

export const formatAdminUtcDate = (
  value: AdminDateValue | null | undefined,
  fallback = '\u2014'
): string => {
  if (value === null || value === undefined) {
    return fallback;
  }

  const timestamp = toAdminTimestamp(value);
  if (!Number.isFinite(timestamp)) {
    return fallback;
  }

  const date = new Date(timestamp);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${day}.${month}.${date.getUTCFullYear()}`;
};
